import { Tab, Tabs, TextField } from "@mui/material";
import { styled } from "@mui/system";
import React from "react";
import { Control, Controller } from "react-hook-form";

export const CustomTab = styled(Tab)(({ theme }) => ({
  fontFamily: "Montserrat",
  fontWeight: "600",
  fontSize: "16px",
  color: "rgba(0, 0, 0, 0.6)",
  backgroundColor: "#EFF3F7", // Fondo claro por defecto
  borderRadius: "8px", // Bordes redondeados para cada Tab
  margin: "0 4px", // Espaciado entre los tabs
  minWidth: "33.33%", // Asegura que cada tab ocupe un 33% del ancho
  "&.Mui-selected": {
    color: "#FFF", // Color de texto blanco cuando está seleccionado
    backgroundColor: "#336B87", // Azul oscuro cuando está seleccionado
  },
}));

export const CustomTabs = styled(Tabs)(({ theme }) => ({
  width: "100%", // Asegura que los tabs ocupen el 100% del ancho
  "& .MuiTabs-indicator": {
    display: "none", // Elimina el borde inferior azul oscuro
  },
  "& .MuiTab-root": {
    textTransform: "none", // Evitar que el texto se transforme
    minWidth: 120, // Ajustar el tamaño de los tabs
  },
  borderRadius: "8px", // Bordes redondeados para la barra de tabs
  backgroundColor: "#EFF3F7", // Fondo claro para la barra de tabs
}));

interface SelectInputProps {
  control: Control;
  name: string;
  label: string;
  selectedOpt: string;
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  children: React.ReactNode;
}

const SelectInput: React.FC<SelectInputProps> = ({
  control,
  name,
  label,
  selectedOpt,
  handleChange,
  children,
}) => {
  return (
    <Controller
      name={name}
      control={control}
      rules={{ required: "Este campo es obligatorio" }}
      render={({ field, fieldState: { error } }) => (
        <TextField
          {...field}
          select
          label={label}
          fullWidth
          variant="outlined"
          error={!!error}
          helperText={error?.message}
          value={selectedOpt}
          onChange={handleChange}
        >
          {children}
        </TextField>
      )}
    />
  );
};

export default SelectInput;
